import { isRough, ProductType } from '@/product/constants/productTypes';

export function getProductTypeDisplayName(productType?: ProductType) {
  if (productType && isRough(productType)) {
    return 'Rough Diamond';
  }

  if (productType === ProductType.Gem) {
    return 'Gem';
  }

  if (productType === ProductType.Jewelry) {
    return 'Jewelry';
  }

  return 'Diamond';
}
